import React from "react";
import { compose } from "redux";

import withTranslations from "../../../../../hocs/withTranslations";
import withUserData from "../../../../../hocs/withUserData";
import useAskFirstNameModal from "../../../../../hooks/useAskFirstNameModal";
import InputText from "../../../common/inputs/InputText/InputText";
import NewModal from "../../NewModal";

const AskFirstNameModal = ({ translate, hideModal, userData }) => {
  const {
    firstName,
    validationError,
    submitting,
    onChangeFirstName,
    handleSave,
    handleDontShow
  } = useAskFirstNameModal({ userData, translate });

  return (
    <NewModal
      hideModal={hideModal}
      title={translate("ask_first_name_modal_title")}
      cancelButtonText={translate("ask_first_name_modal_dont_show")}
      acceptButtonText={translate("ask_first_name_modal_save")}
      acceptButtonDisabled={submitting}
      acceptButtonLoading={submitting}
      hideOnAccept={false}
      onAccept={() => handleSave(hideModal)}
      onCancel={() => handleDontShow()}
    >
      <InputText
        name="first_name"
        label={translate("ask_first_name_modal_label")}
        value={firstName}
        onChange={onChangeFirstName}
        errorMessage={validationError}
        disabled={submitting}
        autoComplete="given-name"
      />
    </NewModal>
  );
};

export default compose(withTranslations, withUserData)(AskFirstNameModal);
